"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Accreditations() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: footerRef,
    isVisible: footerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const accreditations = [{
    name: "Board Certified",
    label: "Board-Certified DNP",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711910/img/certification_dnp.png"
  }, {
    name: "Medical Director",
    label: "MD Medical Oversight",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711910/img/certification_md.png"
  }, {
    name: "Safety Standards",
    label: "Clinical Safety Protocols",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711910/img/certification_safety.png"
  }, {
    name: "Premium Products",
    label: "FDA-Approved Products",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711910/img/certification_fda.png"
  }, {
    name: "Concierge Care",
    label: "Private Concierge Service",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711910/img/certification_concierge.png"
  }, {
    name: "Facial Balancing",
    label: "Advanced Aesthetic Training",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711910/img/certification_training.png"
  }];
  return <section data-section-id="10027" id="follow-the-journey" className="bg-background text-foreground py-8 md:py-28">
      <div className="mx-auto max-w-[1240px] px-6 md:px-16">
        {}
        <div ref={headerRef} className={`mx-auto max-w-[560px] text-center transition-all duration-[900ms] ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <p className="text-[0.8125rem] font-bold uppercase leading-none tracking-[0.2em] text-primary">
            Clinical Excellence
          </p>

          {}
          <div className="mt-6 flex justify-center">
            <div className="h-px w-16 bg-primary/30" />
          </div>

          <h2 className="mt-6 font-default font-medium text-foreground text-2xl sm:text-3xl md:text-4xl" style={{
          fontSize: "clamp(1.75rem, 3vw, 2.5rem)",
          lineHeight: "1.2",
          letterSpacing: "-0.015em"
        }}>
            {"The "}
            <em className={`italic transition-colors duration-[1200ms] ease-out ${headerVisible ? "" : ""}`} style={{
            color: headerVisible ? "hsl(15 45% 75%)" : "hsl(30 5% 45% / 0.4)",
            transition: "color 1200ms ease-out"
          }}>
              standards
            </em>
            {" we uphold for your safety."}
          </h2>

          <p className="mt-6 text-base font-default text-muted-foreground" style={{
          lineHeight: "1.7"
        }}>
            Expertly curated, medically directed, and refined for your peace of mind.
          </p>
        </div>

        {}
        <div ref={gridRef} className="mt-20 grid grid-cols-2 gap-x-10 gap-y-12 md:mt-20 md:grid-cols-3 lg:grid-cols-6 lg:gap-x-10">
          {accreditations.map((item, i) => <div key={i} data-index={i} className={`flex flex-col items-center text-center transition-all ease-out ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDuration: "900ms",
          transitionDelay: `${i * 120}ms`
        }}>
              <div className="flex h-14 items-center justify-center">
                <img src={item.image} data-wvc-srcset={`${item.image}-wvc-srcset`} data-wvc-sizes={`${item.image}-wvc-sizes`} alt={item.name} loading="lazy" decoding="async" className="h-12 md:h-14 w-auto object-contain opacity-80 transition-opacity duration-300 ease-out hover:opacity-100" style={{
              filter: "grayscale(100%) brightness(0.5)"
            }} />
              </div>
              <p className="mt-4 text-[0.8125rem] font-default text-muted-foreground" style={{
            lineHeight: "1.5"
          }}>
                {item.label}
              </p>
            </div>)}
        </div>

        {}
        <div ref={footerRef} className={`mt-14 flex justify-center transition-all duration-[900ms] ease-out ${footerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <Link to="/ContactPage" className="group inline-flex items-center gap-2 text-sm font-default text-foreground" style={{
          textDecoration: "underline",
          textDecorationColor: "hsl(15 45% 75%)",
          textUnderlineOffset: "4px",
          textDecorationThickness: "1px"
        }}>
            <span>View our clinical credentials</span>
            <ArrowRight className="h-4 w-4 transition-transform duration-300 ease-out group-hover:translate-x-1" style={{
            color: "hsl(15 45% 75%)"
          }} />
          </Link>
        </div>
      </div>
    </section>;
}